<template>
  <div
    class="tab-trap"
    @keydown.tab="trapTab($event)"
  >
    <slot />
  </div>
</template>

<script>
export default {

  data: () => ({
    // Queries for finding all the elements that are focussable.
    // @see https://gomakethings.com/how-to-get-the-first-and-last-focusable-elements-in-the-dom/
    focussableQueries: [
      'button',
      'input',
      'select',
      'textarea',
      '[href]',
      '[tabindex]:not([tabindex="-1"])',
    ],
  }),

  computed: {
    focussableQuery () {
      return this.focussableQueries.join(',')
    },
  },

  mounted () {
    this.trapTab()
  },

  methods: {
    trapTab (event = null) {
      const focusableElements = Array.from(this.$el.querySelectorAll(this.focussableQuery))
      const firstElement = focusableElements[0]
      const lastElement = focusableElements[focusableElements.length - 1]

      if (event === null) {
        // If the event is null, then we're trapping the tab key
        // for the first time.
        this.$el.focus()
      } else if (lastElement === event.target && !event.shiftKey) {
        firstElement.focus()
        event.preventDefault()
      } else if (event.shiftKey && firstElement === event.target) {
        lastElement.focus()
        event.preventDefault()
      }
    },
  },
}
</script>
